import { parseSessionViewOccurrenceId } from '@kirin/api-client/helpers/alerts';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

export type SessionViewRoute =
  | { kind: 'none' }
  | { kind: 'loading' }
  | { kind: 'session'; occurrenceId: string };

/**
 * KIR-4785: whether the Alerts splat is a Session view the caller may see.
 * With either flag off the path falls through to the plain Alerts table, so a
 * pasted link never renders an empty Session view.
 */
export function useSessionViewRoute(
  splat: string | undefined
): SessionViewRoute {
  const occurrenceId = parseSessionViewOccurrenceId(splat);
  const { flags, isLoading } = useFeatureFlags([
    flagsmithFeatureFlags.ALERT_SESSION_VIEW,
    flagsmithFeatureFlags.AGENT_SESSION_TIMELINE,
  ]);
  if (!occurrenceId) return { kind: 'none' };
  if (isLoading) return { kind: 'loading' };
  const enabled =
    flags[flagsmithFeatureFlags.ALERT_SESSION_VIEW] === true &&
    flags[flagsmithFeatureFlags.AGENT_SESSION_TIMELINE] === true;
  return enabled ? { kind: 'session', occurrenceId } : { kind: 'none' };
}
